import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import BlockQuiz from "@/components/BlockQuiz.vue";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import sleep from "@/mixins/sleep";
const UiMappers = Vue.extend({
    computed: {
        ...uiMapper.mapState(["formCallIsShown", "breakpoint"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["videoLink", "quiz"]),
        ...dataMapper.mapGetters(["quizAnswer"]),
    },
    methods: {
        ...dataMapper.mapMutations(["updateQuizField", "clearQuiz"]),
    },
});
let PageThanks = class PageThanks extends Mixins(UiMappers, DataMappers) {
    async mounted() {
        document.body.classList.add("modal-open");
        await sleep(7000);
        this.goToPageMain();
    }
    beforeDestroy() {
        document.body.classList.remove("modal-open");
    }
    goToPageMain() {
        // @ts-ignore
        this.$router.push({ path: "/" }).catch(() => { });
    }
};
PageThanks = __decorate([
    Component({
        components: {
            ButtonApp,
            BlockQuiz,
        },
    })
], PageThanks);
export default PageThanks;
